import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/content';
export function Reviews() {
  return <section className="w-full border-t border-line bg-surface py-24 lg:py-32" data-id="element-166" data-mp="2hddo1lbcew3k">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-167" data-mp="2mbfi11ab4ftt">
        <p className="display text-sm tracking-widest text-brand-red" data-id="element-168" data-mp="2me1qr48xp1dm">{reviews.eyebrow}</p>
        <h2 className="display mt-3 text-[clamp(2rem,4.4vw,3.25rem)] leading-[0.98] text-cream" data-id="element-169" data-mp="2r8p6adlymlg2">
          {reviews.heading}
        </h2>

        <div className="mt-12 grid gap-10 md:grid-cols-3" data-id="element-170" data-mp="30aycwse3xuo6">
          {reviews.items.map(review => <figure key={review.name} className="flex h-full flex-col" data-id="element-171" data-mp="351wwq1yb1aw6">
              <div className="flex gap-1" aria-label="Five out of five stars" data-id="element-172" data-mp="3a19tbeez9wby">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand-green text-brand-green" aria-hidden="true" data-id="element-173" data-mp="3f1feqcunmmll" data-mpi={i} />)}
              </div>
              <blockquote className="mt-5 text-lg leading-relaxed text-cream/85" data-id="element-174" data-mp="3jx31ympkt5og">
                “{review.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-6 text-sm" data-id="element-175" data-mp="2mdb1mrjg3bj6">
                <span className="font-semibold text-cream" data-id="element-176" data-mp="2hehpp3jt3sl4">{review.name}</span>
                <span className="block text-cream/55" data-id="element-177" data-mp="2hgkddgxhl9mo">{review.role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}